import React from 'react'
import PropTypes from 'prop-types'
import {Button, Text} from '@chakra-ui/react'
import {searchUrlBuilder} from '../../../utils/url'
import {SearchIcon} from '../../icons'

const RecentSearch = ({recentSearch, closeAndNavigate}) => (
    <Button
        width="full"
        role="button"
        name="recent-search"
        fontSize={'md'}
        onMouseDown={() => {
            closeAndNavigate(searchUrlBuilder(recentSearch))
        }}
        variant="menu-link"
        leftIcon={<SearchIcon width="1rem" height="1rem" color="stokkeGray.dark" />}
    >
        <Text textStyle="Regular Medium">{recentSearch}</Text>
    </Button>
)

RecentSearch.propTypes = {
    recentSearch: PropTypes.string.isRequired,
    closeAndNavigate: PropTypes.func
}

export default RecentSearch
